import { CacheService } from '../../core/cache.service';
import { ResourceConfigItem } from '../../core/resource-config';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';

export abstract class ResourceConfigControlledService {
  protected constructor(
    private readonly _resourceConfigItem: ResourceConfigItem,
    private readonly _environmentService: BdAppEnvironmentService,
    protected readonly _cache: CacheService,
  ) {}

  protected getBaseUrl(): string {
    return this._environmentService.load(
      this._resourceConfigItem.API_TOKENS.BASE,
    );
  }

  protected deleteCacheForKey(key: string): void {
    this._cache.deleteCacheForKey(this.key(key));
  }

  protected key(key: string): string {
    return `${this._resourceConfigItem.API_TOKENS.BASE}__${key}`;
  }
}
